<template>
  <div class="campaign-preview-wrapper">
    <!-- Template Preview (reusa TemplatePreviewPanel) -->
    <template-preview-panel
      title="MESSAGE_PREVIEW"
      :subject="subject"
      :body-html="bodyHtml"
      :purpose-label="purposeLabel"
      :channel-type="channelType"
      :header-image="headerImage"
      :footer-image="footerImage"
      :is-read-only="true"
      :show-controls="false"
      :message-variables="messageVariables"
    />

    <!-- Scheduling Info (campaign-specific) -->
    <q-card v-if="startDate || endDate || leadTimeDays" flat class="scheduling-card q-mt-md">
      <q-card-section class="q-py-sm q-card__section q-card__section--vert">
        <div class="crud-title">
          <span>{{ $gettext('SCHEDULING') }}</span>
        </div>
      </q-card-section>
      <q-card-section class="scheduling-section">
        <div class="scheduling-rows scheduling-rows-inline">
          <div v-if="startDate" class="scheduling-row">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #00613B; flex-shrink: 0;" aria-hidden="true">
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
            <span class="text-caption">{{ $gettext('START_DATE') }}: <strong>{{ startDateFormatted }}</strong></span>
          </div>
          <div v-if="endDate" class="scheduling-row">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #D18E4B; flex-shrink: 0;" aria-hidden="true">
              <path d="M8 2v4"></path>
              <path d="M16 2v4"></path>
              <rect width="18" height="18" x="3" y="4" rx="2"></rect>
              <path d="M3 10h18"></path>
            </svg>
            <span class="text-caption">{{ $gettext('END_DATE') }}: <strong>{{ endDateFormatted }}</strong></span>
          </div>
          <div v-if="leadTimeDays" class="scheduling-row">
            <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" style="color: #0062A9; flex-shrink: 0;" aria-hidden="true">
              <path d="M12 6v6l4 2"></path>
              <circle cx="12" cy="12" r="10"></circle>
            </svg>
            <span class="text-caption">{{ $gettext('LEAD_TIME_DAYS') }}: <strong>{{ leadTimeDays }} {{ $gettext('DAYS') }}</strong></span>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>

<script>
import { Component, Vue, Prop } from 'vue-property-decorator'
import TemplatePreviewPanel from '../template/TemplatePreviewPanel.vue'

@Component({
  name: 'CampaignPreviewPanel',
  components: {
    TemplatePreviewPanel
  }
})
class CampaignPreviewPanel extends Vue {
  // Template-related props
  @Prop({ type: String, default: '' }) subject
  @Prop({ type: String, default: '' }) bodyHtml
  @Prop({ type: String, default: '' }) purposeLabel
  @Prop({ type: [String, Number], default: null }) channelType
  @Prop({ type: String, default: '' }) headerImage
  @Prop({ type: String, default: '' }) footerImage
  @Prop({ type: Array, default: () => [] }) messageVariables

  // Campaign-specific props
  @Prop({ type: String, default: '' }) startDate
  @Prop({ type: String, default: '' }) endDate
  @Prop({ type: [Number, String], default: null }) leadTimeDays

  get startDateFormatted () {
    if (!this.startDate) return ''
    const formatted = this.formatAuditDateTime(this.startDate)
    return formatted ? formatted.split(',')[0].split(' ')[0] : this.startDate
  }

  get endDateFormatted () {
    if (!this.endDate) return this.$gettext('NO_END_DATE')
    const formatted = this.formatAuditDateTime(this.endDate)
    return formatted ? formatted.split(',')[0].split(' ')[0] : this.endDate
  }

  formatAuditDateTime (dateStr) {
    if (!dateStr) return ''

    // Formata a data de auditoria sem conversao de timezone.
    const raw = String(dateStr).trim()
    const match = raw.match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}):(\d{2})(?::\d{2})?)?$/)

    if (match) {
      const [, year, month, day, hours, minutes] = match
      const formattedDate = `${day}/${month}/${year}`

      if (hours && minutes) {
        return `${formattedDate} ${hours}:${minutes}`
      }

      return formattedDate
    }

    return raw
  }
}

export default CampaignPreviewPanel
</script>

<style lang="stylus" scoped>
.campaign-preview-wrapper
  display: flex
  flex-direction: column
  gap: 0

.scheduling-card
  border-radius: 4px
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05)

.scheduling-section
  padding: 16px
  background-color: #fff

.scheduling-rows {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.scheduling-rows-inline {
  flex-direction: row !important;
  gap: 24px;
  align-items: center;
}

.scheduling-row
  display: flex
  align-items: center
  gap: 8px
  color: #2c3f50

  span
    line-height: 1.4
</style>
